<template>
  <div class="page_invoiceDataQuery">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
      </div>
    </div>
    <div class="main-con" v-loading="loading">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>发票数据查询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="qtabs">
        <button class="qtab" :class="{on: tab=='seller'}" @click="switchTab('seller')">按销售方查</button>
        <button class="qtab" :class="{on: tab=='invoice'}" @click="switchTab('invoice')">按发票号码查</button>
        <button class="qtab" :class="{on: tab=='doc'}" @click="switchTab('doc')">按单据编号查</button>
      </div>

      <!-- 按销售方 -->
      <div class="card qcard" v-show="tab=='seller'">
        <div class="qrow">
          <div class="field">
            <label>销售方名称</label>
            <el-autocomplete v-model="sellerForm.sellerName" :fetch-suggestions="sellerSuggest" placeholder="输入销售方名称，支持模糊匹配" style="width:330px" @select="query" @keyup.enter.native="query"></el-autocomplete>
          </div>
          <div class="field">
            <label>开票日期（起）</label>
            <el-date-picker v-model="sellerForm.dateFrom" type="date" value-format="yyyy-MM-dd" placeholder="开始日期" style="width:146px"></el-date-picker>
          </div>
          <div class="field">
            <label>开票日期（止）</label>
            <el-date-picker v-model="sellerForm.dateTo" type="date" value-format="yyyy-MM-dd" placeholder="结束日期" style="width:146px"></el-date-picker>
          </div>
          <div class="field">
            <label>快捷区间</label>
            <div class="chips">
              <span class="chip" :class="{on: quickMonths==3}" @click="setRange(3)">近3个月</span>
              <span class="chip" :class="{on: quickMonths==6}" @click="setRange(6)">近6个月</span>
              <span class="chip" :class="{on: quickMonths==12}" @click="setRange(12)">近1年</span>
              <span class="chip" :class="{on: quickMonths==0}" @click="setRange(0)">全部</span>
            </div>
          </div>
          <el-button size="small" type="primary" @click="query">查询</el-button>
        </div>
      </div>

      <!-- 按发票号码 -->
      <div class="card qcard" v-show="tab=='invoice'">
        <div class="qrow">
          <div class="field">
            <label>发票号码</label>
            <el-input v-model="invoiceForm.invoiceNum" placeholder="输入发票号码，如 24310021" style="width:290px" @keyup.enter.native="query"></el-input>
          </div>
          <el-button size="small" type="primary" @click="query">查询</el-button>
          <div class="hintText">支持带空格、带「-」的号码，系统自动清洗</div>
        </div>
      </div>

      <!-- 按单据编号 -->
      <div class="card qcard" v-show="tab=='doc'">
        <div class="qrow">
          <div class="field">
            <label>单据编号</label>
            <el-input v-model="docForm.docNo" placeholder="OA编号 / 暂支编号 / 日志编号" style="width:290px" @keyup.enter.native="query"></el-input>
          </div>
          <el-button size="small" type="primary" @click="query">查询</el-button>
          <div class="hintText">按前缀自动识别：OA- 报销单 / ZZ- 暂支单 / RZ- 日志报销单</div>
        </div>
      </div>

      <!-- 结果 -->
      <div class="card" v-if="queried">
        <div class="summary">
          <div class="metric">
            <div class="k">发票张数</div>
            <div class="v">{{ output.invoiceCount }}<small v-if="output.dupNumCount">其中 {{ output.dupNumCount }} 个号码重复</small></div>
          </div>
          <div class="metric">
            <div class="k">金额合计</div>
            <div class="v">¥{{ formatMoney(output.amountSum) }}</div>
          </div>
          <div class="metric">
            <div class="k">税额合计</div>
            <div class="v">¥{{ formatMoney(output.taxSum) }}</div>
          </div>
          <div class="metric">
            <div class="k">关联单据</div>
            <div class="v">{{ output.docCount }} 张</div>
          </div>
          <div class="metric" v-if="selection.length > 0">
            <div class="k">已选 {{ selection.length }} 张</div>
            <div class="v">¥{{ formatMoney(selSum) }}</div>
          </div>
          <div class="spacer"></div>
          <div class="acts">
            <el-button size="mini" @click="exportCsv">导出 Excel</el-button>
            <el-button size="mini" type="primary" :disabled="selection.length == 0" :loading="packing" @click="packDownload">打包下载{{ selection.length ? '（' + selection.length + '）' : '' }}</el-button>
          </div>
        </div>

        <el-table ref="table" :data="output.rows" border size="mini" style="width:100%" row-key="id" @selection-change="onSelChange" @sort-change="onSortChange" v-loading="loading">
          <el-table-column type="selection" width="45" align="center" reserve-selection></el-table-column>
          <el-table-column prop="sellerName" label="销售方全称" min-width="200" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column label="发票号码" min-width="120">
            <template slot-scope="{row}">
              <span class="numTxt">{{ row.invoiceNum || '-' }}</span>
              <el-tag v-if="row.dupCount > 1" size="mini" type="danger" effect="plain" style="margin-left:4px">重复入账</el-tag>
            </template>
          </el-table-column>
          <el-table-column prop="invoiceType" label="票种" min-width="110" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="invoiceDate" label="开票日期" min-width="100" sortable="custom"></el-table-column>
          <el-table-column label="入账类型" min-width="90" align="center">
            <template slot-scope="{row}"><el-tag v-if="row.entryType" size="mini" type="info" effect="plain">{{ row.entryType }}</el-tag><span v-else>-</span></template>
          </el-table-column>
          <el-table-column label="入账状态" min-width="90" align="center">
            <template slot-scope="{row}">
              <el-tag v-if="row.docStatus" size="mini" :type="row.docStatus == '已审核' ? 'success' : 'warning'" effect="plain">{{ row.docStatus }}</el-tag>
              <span v-else>-</span>
            </template>
          </el-table-column>
          <el-table-column prop="submitter" label="提交人" min-width="80"></el-table-column>
          <el-table-column prop="costName" label="费用科目" min-width="100" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="amount" label="开票金额" min-width="110" align="right" sortable="custom">
            <template slot-scope="{row}">¥{{ formatMoney(row.amount) }}</template>
          </el-table-column>
          <el-table-column label="税额" min-width="100" align="right">
            <template slot-scope="{row}">
              <span v-if="row.taxAmount != null">¥{{ formatMoney(row.taxAmount) }}</span>
              <span v-else style="color:#909399">-</span>
            </template>
          </el-table-column>
          <el-table-column label="单据编号" min-width="130" :show-overflow-tooltip="true">
            <template slot-scope="{row}">
              <span v-if="row.docId" class="docLink" @click="goDoc(row)" :title="'查看' + (row.docType || '单据')">{{ row.docNo || '-' }}</span>
              <span v-else>{{ row.docNo || '-' }}</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120" align="center" fixed="right">
            <template slot-scope="{row}">
              <el-button type="text" size="mini" :loading="row._downloading" @click="downloadOne(row)">下载发票</el-button>
              <el-button v-if="row.docId" type="text" size="mini" @click="goDoc(row)">查看单据</el-button>
            </template>
          </el-table-column>
          <template slot="empty">
            <div style="padding:30px 0;color:#909399">没有匹配的发票，换个条件试试</div>
          </template>
        </el-table>

        <div class="pagerBar">
          <el-pagination background layout="total, sizes, prev, pager, next" :total="output.total" :current-page.sync="pageIndex" :page-size.sync="pageSize" :page-sizes="[10, 20, 50, 100]" @current-change="query" @size-change="onSizeChange"></el-pagination>
        </div>
      </div>

      <div class="card hintCard" v-else>
        <div class="t1">{{ tabHint.title }}</div>
        <div class="t2">{{ tabHint.desc }}</div>
      </div>

      <div class="footTip">
        入账类型：日志报销、暂支核销；入账状态：审核中、已审核。同一张发票可能出现在多张单据中，系统自动标记重复入账风险。
      </div>
    </div>
  </div>
</template>

<script>
import xz from "../../common";

export default {
  name: 'invoiceDataQuery',
  data() {
    return {
      loading: false,
      packing: false,
      tab: 'seller',
      quickMonths: 12,
      sellerForm: { sellerName: '', dateFrom: '', dateTo: '' },
      invoiceForm: { invoiceNum: '' },
      docForm: { docNo: '' },
      queried: false,
      pageIndex: 1,
      pageSize: 10,
      sortKey: 'date',
      sortDir: 'desc',
      output: { total: 0, rows: [], invoiceCount: 0, amountSum: 0, taxSum: 0, docCount: 0, dupNumCount: 0 },
      selection: [],
    }
  },
  computed: {
    tabHint() {
      if (this.tab == 'seller') return { title: '按销售方查询', desc: '输入销售方名称后，可查看该销售方开具的全部发票，并按开票日期倒序排列。' }
      if (this.tab == 'invoice') return { title: '按发票号码查询', desc: '输入发票号码，查看发票详情及其出现在哪些报销单据中。同一张发票若在多张单据中出现，系统会提示重复入账风险。' }
      return { title: '按单据编号查询', desc: '支持 OA 报销单、暂支单、日志报销单三种编号，系统按前缀自动识别。查询后展示单据名下全部发票。' }
    },
    selSum() {
      let s = 0
      this.selection.forEach(e => { s += Number(e.amount) || 0 })
      return s
    }
  },
  created() {
    this.setRange(12)
  },
  methods: {
    formatMoney(n) {
      return (Number(n) || 0).toLocaleString('zh-CN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },
    isoDate(d) {
      let m = ('0' + (d.getMonth() + 1)).slice(-2), dd = ('0' + d.getDate()).slice(-2)
      return d.getFullYear() + '-' + m + '-' + dd
    },
    setRange(months) {
      this.quickMonths = months
      let today = new Date()
      if (months === 0) {
        this.sellerForm.dateFrom = ''
        this.sellerForm.dateTo = ''
      } else {
        this.sellerForm.dateFrom = this.isoDate(new Date(today.getFullYear(), today.getMonth() - months, today.getDate() + 1))
        this.sellerForm.dateTo = this.isoDate(today)
      }
    },
    switchTab(t) {
      this.tab = t
    },
    sellerSuggest(kw, cb) {
      xz.AdvanceGetFun('InvoiceDataSellerSuggest?keyword=' + encodeURIComponent(kw || '')).then(res => {
        let list = (res && res.status == 'ok' && res.data) ? res.data : []
        cb(list.map(e => ({ value: e })))
      }).catch(() => cb([]))
    },
    buildInput() {
      let input = {
        queryType: this.tab,
        pageIndex: this.pageIndex,
        pageSize: this.pageSize,
        sortKey: this.sortKey,
        sortDir: this.sortDir,
      }
      if (this.tab == 'seller') {
        input.sellerName = (this.sellerForm.sellerName || '').trim()
        input.dateFrom = this.sellerForm.dateFrom || ''
        input.dateTo = this.sellerForm.dateTo || ''
      } else if (this.tab == 'invoice') {
        input.invoiceNum = (this.invoiceForm.invoiceNum || '').replace(/[\s\-－—]/g, '')
        if (!input.invoiceNum) {
          this.$message.warning('请输入发票号码')
          return null
        }
      } else {
        input.docNo = (this.docForm.docNo || '').replace(/\s/g, '')
        if (!input.docNo) {
          this.$message.warning('请输入单据编号')
          return null
        }
      }
      return input
    },
    query() {
      let input = this.buildInput()
      if (!input) return
      this.loading = true
      xz.AdvanceFun(input, 'InvoiceDataQuery').then(res => {
        this.loading = false
        if (res && res.status == 'ok' && res.data) {
          this.queried = true
          this.output = Object.assign({ total: 0, rows: [], invoiceCount: 0, amountSum: 0, taxSum: 0, docCount: 0, dupNumCount: 0 }, res.data)
        } else {
          this.$message.error((res && res.msg) || '查询失败')
        }
      }).catch(() => {
        this.loading = false
        this.$message.error('查询出错，请重试')
      })
    },
    onSizeChange() {
      this.pageIndex = 1
      this.query()
    },
    onSortChange({ prop, order }) {
      if (!order) {
        this.sortKey = 'date'
        this.sortDir = 'desc'
      } else {
        this.sortKey = prop == 'amount' ? 'amount' : 'date'
        this.sortDir = order == 'ascending' ? 'asc' : 'desc'
      }
      this.query()
    },
    onSelChange(val) {
      this.selection = val
    },
    //跳转到对应核销单详情：日志报销单 /logReiDtl，暂支单 /tePaymentDtl
    goDoc(row) {
      if (!row.docId) return
      if ((row.docType || '').indexOf('暂支') > -1) {
        this.$router.push({ path: '/tePaymentDtl', query: { id: row.docId, type: 'dtl', activeName: '待核销' } })
      } else {
        this.$router.push({ path: '/logReiDtl', query: { type: 'dtl', id: row.docId } })
      }
    },
    //单张下载：文件名 发票_{发票号}_{开票日期}.{扩展名}
    downloadOne(row) {
      this.$set(row, '_downloading', true)
      xz.AdvanceExpFun(String(row.id), 'InvoiceDataDownload').then(res => {
        this.$set(row, '_downloading', false)
        if (!res) {
          this.$message.error('下载失败')
          return
        }
        if (res.type && res.type.indexOf('json') > -1) {
          res.text().then(t => this.$message.error(t || '下载失败'))
          return
        }
        let ext = 'pdf'
        let src = row.fileName || row.fileUrl || ''
        let m = /\.([A-Za-z0-9]{2,5})(?:\?|$)/.exec(src)
        if (m) ext = m[1].toLowerCase()
        let date = (row.invoiceDate || '').replace(/-/g, '')
        this.saveBlob(res, '发票_' + (row.invoiceNum || '未命名') + '_' + date + '.' + ext)
      }).catch(() => {
        this.$set(row, '_downloading', false)
        this.$message.error('下载出错，请重试')
      })
    },
    //打包下载：勾选多行生成 zip，内含全部发票原件 + 一份 发票清单.xlsx
    packDownload() {
      if (this.selection.length == 0) {
        this.$message.warning('请先勾选发票')
        return
      }
      let label = this.tab == 'seller' ? '销售方查询' : (this.tab == 'invoice' ? '发票' + (this.invoiceForm.invoiceNum || '') : '单据' + (this.docForm.docNo || ''))
      let zipName = '发票打包_' + label + '_' + this.selection.length + '张'
      this.packing = true
      xz.AdvanceExpFun({ ids: this.selection.map(e => e.id), zipName: zipName }, 'InvoicePackDownload').then(res => {
        this.packing = false
        if (!res) {
          this.$message.error('打包失败')
          return
        }
        if (res.type && res.type.indexOf('json') > -1) {
          res.text().then(t => this.$message.error(t || '打包失败'))
          return
        }
        this.saveBlob(res, zipName + '.zip')
        this.$message.success('已打包 ' + this.selection.length + ' 张发票，开始下载')
      }).catch(() => {
        this.packing = false
        this.$message.error('打包出错，请重试')
      })
    },
    //导出 CSV（取当前条件下全部数据）
    exportCsv() {
      let input = this.buildInput()
      if (!input) return
      input.pageIndex = 1
      input.pageSize = 50000
      this.loading = true
      xz.AdvanceFun(input, 'InvoiceDataQuery').then(res => {
        this.loading = false
        if (!res || res.status != 'ok' || !res.data) {
          this.$message.error((res && res.msg) || '导出失败')
          return
        }
        let rows = res.data.rows || []
        let head = ['销售方全称', '发票号码', '票种', '开票金额', '税额', '开票日期', '费用科目', '入账类型', '入账状态', '提交人', '单据编号', '单据类型']
        let lines = [head.join(',')]
        rows.forEach(r => {
          lines.push([
            r.sellerName, r.invoiceNum, r.invoiceType,
            (Number(r.amount) || 0).toFixed(2),
            r.taxAmount != null ? (Number(r.taxAmount) || 0).toFixed(2) : '',
            r.invoiceDate, r.costName, r.entryType, r.docStatus, r.submitter, r.docNo, r.docType
          ].map(this.csvCell).join(','))
        })
        let blob = new Blob(['﻿' + lines.join('\r\n')], { type: 'text/csv;charset=utf-8' })
        this.saveBlob(blob, '发票清单_' + rows.length + '条.csv')
        this.$message.success('已导出 ' + rows.length + ' 条发票记录')
      }).catch(() => {
        this.loading = false
        this.$message.error('导出出错，请重试')
      })
    },
    csvCell(s) {
      s = String(s == null ? '' : s)
      if (/[",\n]/.test(s)) return '"' + s.replace(/"/g, '""') + '"'
      return s
    },
    saveBlob(blob, name) {
      let url = window.URL.createObjectURL(blob)
      let a = document.createElement('a')
      a.href = url
      a.download = name
      document.body.appendChild(a)
      a.click()
      setTimeout(() => {
        window.URL.revokeObjectURL(url)
        a.remove()
      }, 1500)
    }
  }
}
</script>

<style lang="scss" scoped>
.page_invoiceDataQuery {
  .main-con {
    padding: 0 20px 40px;
  }
  .qtabs {
    display: flex;
    margin: 16px 0;
    .qtab {
      height: 40px;
      padding: 0 22px;
      border: 1px solid #E4E7ED;
      margin-left: -1px;
      background: #fff;
      color: #303133;
      font-size: 14px;
      cursor: pointer;
      display: flex;
      align-items: center;
      transition: .15s;
      &:first-child {
        margin-left: 0;
        border-radius: 4px 0 0 4px;
      }
      &:last-child {
        border-radius: 0 4px 4px 0;
      }
      &:hover {
        color: #409EFF;
      }
      &.on {
        color: #409EFF;
        background: #ECF5FF;
        border-color: #409EFF;
        position: relative;
        z-index: 2;
      }
    }
  }
  .card {
    background: #fff;
    border: 1px solid #EBEEF5;
    border-radius: 4px;
    & + .card {
      margin-top: 14px;
    }
  }
  .qcard {
    padding: 18px 20px;
    margin-bottom: 14px;
  }
  .qrow {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;
    align-items: flex-end;
    .field {
      display: flex;
      flex-direction: column;
      gap: 6px;
      label {
        font-size: 13px;
        color: #606266;
      }
    }
    .hintText {
      font-size: 12px;
      color: #909399;
      padding-bottom: 8px;
    }
  }
  .chips {
    display: flex;
    gap: 6px;
    .chip {
      font-size: 12px;
      color: #606266;
      background: #fff;
      border: 1px solid #DCDFE6;
      border-radius: 4px;
      padding: 0 9px;
      height: 32px;
      line-height: 30px;
      cursor: pointer;
      transition: .15s;
      &:hover {
        color: #409EFF;
        border-color: #C6E2FF;
        background: #ECF5FF;
      }
      &.on {
        color: #fff;
        background: #409EFF;
        border-color: #409EFF;
      }
    }
  }
  .summary {
    display: flex;
    align-items: center;
    gap: 18px;
    padding: 14px 20px;
    border-bottom: 1px solid #EBEEF5;
    flex-wrap: wrap;
    .metric {
      display: flex;
      flex-direction: column;
      gap: 2px;
      padding-right: 18px;
      border-right: 1px solid #EBEEF5;
      .k {
        font-size: 12px;
        color: #909399;
      }
      .v {
        font-size: 18px;
        font-weight: 500;
        color: #303133;
        small {
          font-size: 12px;
          font-weight: 400;
          color: #C0C4CC;
          margin-left: 5px;
        }
      }
    }
    .spacer {
      flex: 1;
    }
    .acts {
      display: flex;
      gap: 8px;
      align-items: center;
    }
  }
  .numTxt {
    font-variant-numeric: tabular-nums;
  }
  .pagerBar {
    padding: 11px 20px;
    border-top: 1px solid #EBEEF5;
    display: flex;
    justify-content: flex-end;
  }
  .hintCard {
    padding: 40px 24px;
    text-align: center;
    .t1 {
      font-size: 14px;
      color: #606266;
      margin-bottom: 6px;
    }
    .t2 {
      font-size: 12px;
      color: #909399;
      line-height: 1.7;
      max-width: 560px;
      margin: 0 auto;
    }
  }
  .footTip {
    margin-top: 16px;
    font-size: 12px;
    color: #909399;
    line-height: 1.8;
  }
  .docLink {
    color: #1967d2;
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
